module.exports = __webpack_public_path__ + "media/images/gn_icon02_on-90334ef2eb63c296dd1af1f27d6ef9a8.png";